// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var DataSetVersion;
(function (DataSetVersion) {
    DataSetVersion["Table"] = "table";
})(DataSetVersion || (DataSetVersion = {}));
